import React from 'react';

const Button = ({ label, ...rest }) => {
    return (
        <button type="submit" {...rest}>
            {label}
        </button>
    );
};

export default Button;
